import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import NotificationsIcon from "@mui/icons-material/Notifications";
import COMPANYROUTES from "../../routes/company/company.Route";
import SideBarItem from "../adminLayout/components/SideBarItem";
// import PaymentSidebar from "../../company/components/PaymentSidebar";
import Container from "../../components/commonContainer/Container";
import "../../company/styles/CompanyTheme.scss";

function CompanyLayout() {
  return (
    <div className="admin-layout">
      <input type="checkbox" style={{ display: "none" }} id="humberIcon" />
      <label className="mobile_open" htmlFor="humberIcon"></label>
      <div className="sidebar">
        <div className="sidebarlogo">Company Logo</div>
        <div className="sidenav_container">
          <ul>
            {COMPANYROUTES?.map((item: any, i: number) => (
              <SideBarItem key={i} item={item} />
            ))}
          </ul>
        </div>
      </div>
      <div className="main_container">
        <Navbar>
          <p>Company</p>
          <NotificationsIcon />
          <div className="admin_menu">
            <AccountCircleIcon />
            <div className="dropdown">
              <div className="dropdown_content">
                <p
                  className="logout_text"
                  onClick={() => {
                    localStorage.clear();
                    window.location.href = "/company-login";
                  }}
                >
                  Logout
                </p>
              </div>
            </div>
          </div>
        </Navbar>
        <div className="container_main">
          <Container>
            <div className="company-theme">
              <Outlet />
            </div>
          </Container>
        </div>
      </div>
      {/* <div className="payment-sidebar">
        <PaymentSidebar />
      </div> */}
    </div>
  );
}

export default CompanyLayout;
